var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.803,
    height: 14.803,
    viewBox: "0 0 14.803 14.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-message-circle",
    "data-name": "Icon feather-message-circle",
    d: "M19.3,11.49a6.892,6.892,0,0,1-.74,3.125,6.99,6.99,0,0,1-6.25,3.865,6.892,6.892,0,0,1-3.125-.74L4.5,19.3l1.563-4.688a6.892,6.892,0,0,1-.74-3.125A6.99,6.99,0,0,1,9.188,5.24a6.892,6.892,0,0,1,3.125-.74h.411A6.974,6.974,0,0,1,19.3,11.079Z",
    transform: "translate(-4.5 -4.5)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon-message.8514ec41f4ed123d4e3bf8a599b8fcdd.svg";
export { ForwardRef as ReactComponent };